// removed by extract-text-webpack-plugin
module.exports = {"content-style":"dialog-module-content-style-3f6bb5648792f202672585aa531f37d7--","warning":"dialog-module-warning-e4e9d0d3be696cb98cb0202594dfee5a--","close-icon":"dialog-module-close-icon-f8dbaf3d3627420205987d3b5c51f5da--"};


//////////////////
// WEBPACK FOOTER
// /src/components/UiComponents/Dialog/dialog.module.scss
// module id = 1647
// module chunks = 0